<template>
  <b-row>
    <b-col class="white-box" style="height: 80px;">
      <div v-if="showDiff" class="card-period-diff">
        <slot name="diff"></slot>
        <slot name="arrow"></slot>
      </div>
      <b-row class="card-align-text">
        <b-col cols="auto" class="pl-1 pr-0">
          <slot name="image"></slot>
        </b-col>
        <b-col col class="line-height-1 text-base pl-2 pl-lg-2">
          <div class="text-18 text-left" name="info">{{ info }}</div>
          <div class="text-14 text-left" name="title">{{ title }}</div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: [
    'info',
    'title',
    'showDiff'
  ]
}
</script>

<style>
  .img-box {
    display: flex;
    justify-content: center;
    height: 70px;
    width: 70px;
  }

  .card-period-diff {
    position: absolute;
    top: 5px;
    right: 25px;
    float: right;
    display: flex;
    align-items: center;
    height: fit-content;
  }
  div[name="title"] {
    word-wrap: break-word;
  }
</style>
